/**
 * Client-side mirror of the server's recall guard (functions/src/approval/recall.js's
 * recallBlockReason). The backend is the authority and refuses anything this misses; this
 * exists only so the "Recall matter" button is never offered when it would fail.
 *
 * Recall is offered only while approval has not started moving: the matter must be
 * pending approval and no step may have a DECIDED outcome yet (`approved`, `rejected`,
 * or `info_requested`). `waiting` and `pending` are both still recallable — `pending`
 * just means an approver has been emailed for their turn, which is true for group 0 the
 * instant a matter is submitted, so treating it as blocking would hide the button always.
 */

export const RECALLABLE_MATTER_STATUS = 'pending_approval';

/**
 * @param {object}  args
 * @param {object}  args.matter    the matter document
 * @param {Array}   args.steps     every doc from matters/{id}/approvalSteps
 * @param {boolean} args.isOwner   viewer is matter.createdBy
 * @param {boolean} args.isAdmin   viewer has the admin/superadmin role
 * @returns {boolean}
 */
const DECIDED_STEP_STATUSES = ['approved', 'rejected', 'info_requested', 'skipped'];

export function canRecallMatter({ matter, steps, isOwner, isAdmin }) {
  if (!matter) return false;
  if (!isOwner && !isAdmin) return false;
  if (matter.status !== RECALLABLE_MATTER_STATUS) return false;
  const chain = Array.isArray(steps) ? steps : [];
  return chain.every((step) => step && !DECIDED_STEP_STATUSES.includes(step.status));
}
